module.exports = __webpack_public_path__ + "static/media/icon-delete.251346f6.png";